<template>
  <div>
    <h3>Sync Planday Venues</h3>

    <vs-button
        @click="syncVenues"
        id="sync-venues-button"
        class="mt-4"
        size="large"
      >Sync Venues</vs-button>

    <h5 v-if="message !== null">{{ message }}</h5>

    <vs-table
      v-if="message === null"
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="syncedVenues"
      @selected="onVenueClicked(selected)"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                syncedVenues.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : syncedVenues.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="plandayPortalId">Planday Portal ID</vs-th>
        <vs-th sort-key="didSync">Synced</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.plandayPortalId }}</p>
            </vs-td>
            <vs-td>
              <vs-icon v-if="tr.didSync || tr.alreadySynced" icon="check" size="small" color="white" bg="lightgreen" round></vs-icon>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      syncedVenues: [],

      message: null,

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.syncedVenues.length;
    },
  },
  methods: {
    syncVenues: function() {
      this.$vs.loading()

      this.$http.post(process.env.VUE_APP_API +'/venues/planday')
        .then(resp => {
          console.log(resp);

          if (resp.data.hasMessage) {
            this.message = resp.data.message;
          }
          
          this.syncedVenues = resp.data.venues;

          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Planday Venues synced'
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color:'danger',
            title:'Error',
            text:'Could not sync Planday Venues:' + err
          });
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    onVenueClicked(venue) {
      localStorage.setItem('rekom.life.venueName', venue.name)
      localStorage.setItem('rekom.life.venueId', venue.venueId)
      
      this.$http.defaults.headers.common['VenueId'] = venue.venueId
      console.log("Setting venue header:", venue.venueId);

      this.$router.push({ name: 'venue-home' }).catch(() => {})
    },
  },
  created() {
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>